export default __webpack_public_path__ + "static/media/carb.84fdf95c.png";